import React, { useMemo } from 'react'
import { AutocompleteInput, required, useInfiniteGetList } from 'react-admin'
import { NewsBlogSelectInputProps } from './type'

// const typeChoices = [
//   // { id: 'news', name: 'News' },
//   // { id: 'blogs', name: 'Blog' },
//   { id: 'news', name: 'ข่าว' },
//   { id: 'blogs', name: 'บทความ' },
// ]

const typeLabel = {
  news: 'ข่าว',
  blogs: 'บทความ',
}

export const MyAutocompleteInput: React.FC<NewsBlogSelectInputProps> = ({ source, type, disable }) => {
  const { data, isLoading } = useInfiniteGetList(type, {
    sort: { field: 'end_date', order: 'DESC' },
    filter: { is_published: true, is_expired: false },
  })

  // Transform the data into choices format
  const choices = useMemo(() => {
    if (data) {
      const flattenedData = (data?.pages.flatMap((page) => page.data) || []).map((data) => ({
        id: data.id,
        title_th: data.title_th,
      }))
      return flattenedData
    }
    return []
  }, [data])

  return (
    <AutocompleteInput
      isLoading={isLoading}
      source={source}
      choices={choices}
      optionValue='id' // Adjust the field name according to your API response
      optionText='title_th' // Adjust the field name according to your API response
      fullWidth
      label={`หัวข้อ ${typeLabel[type] || ''}`}
      validate={[required()]}
      disabled={disable}
    />
  )
}
